import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-invoice-detail',
  templateUrl: './app-project-invoice-detail.component.html',
  styleUrls: ['./app-project-invoice-detail.component.scss']
})
export class AppProjectInvoiceDetailComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
